export default "__VITE_ASSET__926f5b45__"